// Gauge geometry for the `.progress` meters (spend, agent hours). One clamp:
// every meter on the Billing screen paints the same way, and an over-cap value
// fills the bar rather than overflowing it.
// Pure — the `role="progressbar"` ARIA values stay the caller's job, because
// they carry the REAL number (`aria-valuenow`), not the clamped width.

/**
 * `used` as a 0..100 bar width. Clamped at both ends: a zero/negative `total`
 * has no meaningful ratio (⇒ 0, an empty bar, never a divide-by-zero `NaN`
 * width), and past `total` the bar sits full instead of running off its track.
 */
export function progressPct(used: number, total: number): number {
  if (!(total > 0)) return 0;
  const ratio = (used / total) * 100;
  // A NaN reading would paint `width: NaN%`, which CSS drops — leaving the bar
  // at whatever it showed last. An empty bar is the honest fallback.
  if (Number.isNaN(ratio)) return 0;
  return Math.min(100, Math.max(0, ratio));
}
